import $ from 'jquery'
import Cookies from 'js-cookie'

/*$(document).ready(function () {
    var footer = $('#colophon .footer-widgets');

    function initIsotope() {
        let window_width = $(window).width();
        $(footer).isotope('destroy');
        $(footer).isotope({
            itemSelector: '.footer-widget',
            percentPosition: true,
            getSortData: {
                number: '[data-sortId] parseInt'
            },
            sortBy: (window_width > 1100) ? ['original-order'] : ['number'],
            masonry: {
                columnWidth: '.footer-widget'
            }
        })
    }

    initIsotope();

    $(window).on('resize', (event) => {
        initIsotope();
    })

});*/

window.addEventListener('load', function() {

    setTimeout(function() {
        if ( Cookies.get('gsPopupActive') === 1 || Cookies.get('gsPopupActive') === undefined ) {
            var modal = document.getElementById('gsPopup');
            $(modal).modal('show');
        }

    }, 2000);
});


$('#gsPopup').on('hidden.bs.modal', function () {
    $('#gsPopup').html('')
    Cookies.set('gsPopupActive', 0)
});

$('a[href="#cookies"]').on('click', (e) => {
    e.preventDefault()
    window.openAxeptioCookies()
})
